<div class="main">
  <div class="row">
    <div class="col-md-12">
      <a
      type="button"
      class="close pull-right close-profile"
      aria-label="close"
      (click)="close()"
      >
      <span aria-hidden="true">×</span>
    </a>
    </div>
  </div>
  <div class="text-contain">
    <h3 style="color: #f26722; font-size: 19px; font-weight: bold">
      Subscribe
    </h3>

    <!-- <button
    type="button"
    class="close pull-right"
    aria-label="close"
    (click)="close()"
  >
    <span aria-hidden="true">×</span>
  </button> -->
  </div>
  <div class="list-offer">
    <div
      class="subscription-form d-flex flex-row justify-content-center text-center bx-blue mb-3"
    >
      <form #myForm="ngForm" (ngSubmit)="submit()">
        <div
          class="subscription-type pl-3 pr-3 m-2 mb-4 cursor-pointer d-flex align-items-center"
          *ngFor="let priceitem of PriceList; let i = index"
          [ngClass]="selectedPrice == priceitem.priceStripeId ? 'active' : ''"
          (click)="AllData(priceitem.priceStripeId)"
        >
          <input
            type="radio"
            [checked]="selectedPrice == priceitem.priceStripeId ? true : false"
            (change)="onRadioChange(priceitem)"
          />
          <span class="ml-2 mr-2">{{ "$" + priceitem?.unit_amount }}</span
          ><br />
          <label for=""
            >{{
              getPriceLabel(priceitem.recurring?.interval)
            }}
            Subscription</label
          >
        </div>
        <div>
          <tui-loader
            style="display: inline-flex"
            class="tui-space_right-2"
            [showLoader]="showLoader"
            [inheritColor]="true"
            [overlay]="true"
          >
            <div class="text-center">
              <button type="submit" class="page-btn mx-1">
                Pay & Continue
              </button>
            </div>
          </tui-loader>
        </div>
      </form>
    </div>
  </div>
</div>
